import {Action} from '@ngrx/store';
import {KeyValueOptionItem} from '../../../clients/veranstaltungen';
import {Landkreis, PandemieLevelSchwellenwert, PandemieMandantOptions} from '../../../clients/pandemie';
import {VeranstaltungsTyp, VeranstaltungsTypFeld, VeranstaltungsTypFeldSelectOption, VeranstaltungsTypDetail} from '../../../clients/veranstaltungstypen';

export const PAGE_STATE_RESET = '[MandantenverwaltungTypspezifikationPage] Page State reset';

export const VERANSTALTUNGS_TYPEN_LADEN = '[MandantenverwaltungTypspezifikationPage] Veranstaltungstypen laden';
export const VERANSTALTUNGS_TYP_GEWAEHLT = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ gewählt';
export const VERANSTALTUNGS_TYP_HINZUFUEGEN = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ hinzufügen';
export const VERANSTALTUNGS_TYP_ENTFERNEN = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ entfernen';
export const VERANSTALTUNGS_TYP_STAMM_INPUT = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ Stamm Eingabe';
export const VERANSTALTUNGS_TYP_SPEICHERN = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ speichern';

export const VERANSTALTUNGS_TYP_FELD_INPUT = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ Feld Eingabe';
export const VERANSTALTUNGS_TYP_FELD_GEWAEHLT = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ Feld gewählt';
export const VERANSTALTUNGS_TYP_FELDER_LADEN = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ Feld laden';
export const VERANSTALTUNGS_TYP_FELD_HINZUFUEGEN = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ Feld hinzufügen';
export const VERANSTALTUNGS_TYP_FELD_EINGABE_ABBRECHEN = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ Feld Eingabe abbrechen';
export const VERANSTALTUNGS_TYP_FELD_SPEICHERN = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ Feld speichern';
export const VERANSTALTUNGS_TYP_FELD_SELECT_OPTION_GEWAEHLT = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ Feld Select Option gewählt';
export const VERANSTALTUNGS_TYP_FELD_SELECT_OPTION_SPEICHERN = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ Feld Select Option speichern';
export const VERANSTALTUNGS_TYP_FELD_SELECT_OPTION_LOESCHEN = '[MandantenverwaltungTypspezifikationPage] Veranstaltung Typ Feld Select Option löschen';

export const MANDANTEN_KONFIGURATION_SPEICHERN = '[MandantenverwaltungTypspezifikationPage] Mandanten Konfiguration Speichern';
export const SAISONS_KONFIGURATION_SPEICHERN = '[MandantenverwaltungTypspezifikationPage] Saisons Konfiguration Speichern';
export const PANDEMIE_CONFIG_INPUT = '[MandantenverwaltungTypspezifikationPage] Pandemie Config Eingabe';
export const PANDEMIE_SCHWELLENWERTE_CONFIG_INPUT = '[MandantenverwaltungTypspezifikationPage] Pandemie Schwellenwerte Config Eingabe';
export const PANDEMIE_LANDKREISE_CONFIG_INPUT = '[MandantenverwaltungTypspezifikationPage] Pandemie Landkreise Config Eingabe';

export const ADMIN_ROLLEN_LADEN = '[MandantenverwaltungTypspezifikationPage] Admin-Rollen laden';
export const ADMIN_ROLLEN_SETZEN = '[MandantenverwaltungTypspezifikationPage] Admin-Rollen setzen';
export const ADMIN_ROLLEN_HINZUFUEGEN = '[MandantenverwaltungTypspezifikationPage] Admin-Rolle hinzufügen';
export const ADMIN_ROLLEN_LOESCHEN = '[MandantenverwaltungTypspezifikationPage] Admin-Rolle löschen';

// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// Mandanten Konfiguration
export class VeranstaltungsTypenLaden implements Action {
    readonly type = VERANSTALTUNGS_TYPEN_LADEN;

    constructor() {}
}
export class VeranstaltungsTypGewaehlt implements Action {
    readonly type = VERANSTALTUNGS_TYP_GEWAEHLT;

    constructor(public payload: VeranstaltungsTyp) {}
}
export class VeranstaltungsTypHinzufuegen implements Action {
    readonly type = VERANSTALTUNGS_TYP_HINZUFUEGEN;

    constructor() {}
}
export class VeranstaltungsTypEntfernen implements Action {
    readonly type = VERANSTALTUNGS_TYP_ENTFERNEN;

    constructor() {}
}
export class VeranstaltungsTypStammInput implements Action {
    readonly type = VERANSTALTUNGS_TYP_STAMM_INPUT;

    constructor(public payload: VeranstaltungsTypDetail) {}
}
export class VeranstaltungsTypSpeichern implements Action {
    readonly type = VERANSTALTUNGS_TYP_SPEICHERN;

    constructor() {}
}


export class VeranstaltungsTypFeldInput implements Action {
    readonly type = VERANSTALTUNGS_TYP_FELD_INPUT;

    constructor(public payload: VeranstaltungsTypFeld) {}
}
export class VeranstaltungsTypFeldGewaehlt implements Action {
    readonly type = VERANSTALTUNGS_TYP_FELD_GEWAEHLT;

    constructor(public payload: VeranstaltungsTypFeld) {}
}
export class VeranstaltungsTypFelderLaden implements Action {
    readonly type = VERANSTALTUNGS_TYP_FELDER_LADEN;

    constructor() {}
}
export class VeranstaltungsTypFeldHinzufuegen implements Action {
    readonly type = VERANSTALTUNGS_TYP_FELD_HINZUFUEGEN;

    constructor() {}
}
export class VeranstaltungsTypFeldSpeichern implements Action {
    readonly type = VERANSTALTUNGS_TYP_FELD_SPEICHERN;

    constructor() {}
}
export class VeranstaltungsTypFeldEingabeAbbrechen implements Action {
    readonly type = VERANSTALTUNGS_TYP_FELD_EINGABE_ABBRECHEN;

    constructor() {}
}
export class VeranstaltungsTypFeldSelectOptionGewaehlt implements Action {
    readonly type = VERANSTALTUNGS_TYP_FELD_SELECT_OPTION_GEWAEHLT;

    constructor(public payload: VeranstaltungsTypFeldSelectOption) {}
}
export class VeranstaltungsTypFeldSelectOptionSpeichern implements Action {
    readonly type = VERANSTALTUNGS_TYP_FELD_SELECT_OPTION_SPEICHERN;

    constructor(public payload: VeranstaltungsTypFeldSelectOption) {}
}
export class VeranstaltungsTypFeldSelectOptionLoeschen implements Action {
    readonly type = VERANSTALTUNGS_TYP_FELD_SELECT_OPTION_LOESCHEN;

    constructor(public payload: VeranstaltungsTypFeldSelectOption) {}
}

export class MandantenKonfigurationSpeichern implements Action {
    readonly type = MANDANTEN_KONFIGURATION_SPEICHERN;

    constructor() {}
}
export class SaisonsKonfigurationSpeichern implements Action {
    readonly type = SAISONS_KONFIGURATION_SPEICHERN;

    constructor(public payload: Array<KeyValueOptionItem>) {}
}


export class PandemieConfigInput implements Action {
    readonly type = PANDEMIE_CONFIG_INPUT;

    constructor(public payload: PandemieMandantOptions) {}
}

export class PandemieSchwellenwerteConfigInput implements Action {
    readonly type = PANDEMIE_SCHWELLENWERTE_CONFIG_INPUT;

    constructor(public payload: Array<PandemieLevelSchwellenwert>) {}
}

export class PandemieLandkreiseConfigInput implements Action {
    readonly type = PANDEMIE_LANDKREISE_CONFIG_INPUT;

    constructor(public payload: Array<Landkreis>) {}
}

export class AdminRollenLadenAction implements Action {
    readonly type = ADMIN_ROLLEN_LADEN;

    constructor() {
    }
}

export class AdminRollenSetzenAction implements Action {
    readonly type = ADMIN_ROLLEN_SETZEN;

    constructor(public payload: Array<string>) {
    }
}

export class AdminRollenHinzufuegenAction implements Action {
    readonly type = ADMIN_ROLLEN_HINZUFUEGEN;

    constructor(public payload: Array<string>) {
    }
}

export class AdminRollenLoeschenAction implements Action {
    readonly type = ADMIN_ROLLEN_LOESCHEN;

    constructor() {
    }
}


export type Actions =
    | PageStateResetAction
    | VeranstaltungsTypenLaden
    | VeranstaltungsTypGewaehlt
    | VeranstaltungsTypHinzufuegen
    | VeranstaltungsTypEntfernen
    | VeranstaltungsTypStammInput
    | VeranstaltungsTypSpeichern
    | VeranstaltungsTypFeldInput
    | VeranstaltungsTypFeldGewaehlt
    | VeranstaltungsTypFeldSelectOptionGewaehlt
    | VeranstaltungsTypFeldSelectOptionSpeichern
    | VeranstaltungsTypFeldSelectOptionLoeschen
    | MandantenKonfigurationSpeichern
    | SaisonsKonfigurationSpeichern
    | PandemieConfigInput
    | PandemieSchwellenwerteConfigInput
    | VeranstaltungsTypFelderLaden
    | VeranstaltungsTypFeldHinzufuegen
    | VeranstaltungsTypFeldEingabeAbbrechen
    | VeranstaltungsTypFeldSpeichern
    | AdminRollenLadenAction
    | AdminRollenSetzenAction
    | AdminRollenHinzufuegenAction
    | AdminRollenLoeschenAction
    ;
